import { ToggleButtonGroup, Icons } from 'greener-ui-library';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const ASSETS_VIEWS = {
  LIST: '/assets',
  MAP: '/assets/location',
};

export const AssetsViewToggle = () => {
  const [assetsView, setAssetsView] = useState(ASSETS_VIEWS.LIST);
  const navigate = useNavigate();

  useEffect(() => {
    setAssetsView(location.pathname);
  }, [location.pathname, setAssetsView]);

  const toggleViewButtonContent = [
    {
      value: ASSETS_VIEWS.LIST,
      content: <Icons.ViewHeadline />,
      buttonProps: { onClick: () => navigate(ASSETS_VIEWS.LIST) },
    },
    {
      value: ASSETS_VIEWS.MAP,
      content: <Icons.LocationOn />,
      buttonProps: { onClick: () => navigate(ASSETS_VIEWS.MAP) },
    },
  ];

  return (
    <ToggleButtonGroup
      size="large"
      selectedValue={assetsView}
      buttons={toggleViewButtonContent}
      exclusive
      onChange={(value) => setAssetsView(value as string)}
    />
  );
};
